import React, { createContext, forwardRef, useMemo } from "react";
import { VariableSizeList } from "react-window";

export const StickyListContext = createContext();
StickyListContext.displayName = "StickyListContext";

const StickyRow = ({ columns, style }) => (
  <div style={style} className="itemcode itemcode-headers odd">
    <div className="itemcode-headers">
      {columns.map((column) => (
        <div
          key={`itemcode-headers-column-${column.id}`}
          className={`header header-${column.id}`}
          title={column.label}
        >
          {column.label}
        </div>
      ))}
    </div>
  </div>
);

const ItemWrapper = ({ data, index, style }) => {
  const { ItemRenderer } = data;
  if (index === 0) return null;
  return <ItemRenderer data={data} index={index} style={style} />;
};

export const innerElementType = forwardRef(({ children, style, ...rest }, ref) => (
  <StickyListContext.Consumer>
    {({ columns, contentWidth }) => (
      <div ref={ref} style={{ ...style, minWidth: contentWidth }} {...rest}>
        <StickyRow
          columns={columns}
          style={{ top: 0, left: 0, width: "100%", height: 45 }}
        />
        {children}
      </div>
    )}
  </StickyListContext.Consumer>
));

const StickyList = ({ children, contentWidth, ...rest }) => {
  const itemDataWithRenderer = useMemo(
    () => ({ ...rest.itemData, ItemRenderer: children }),
    [rest.itemData, children],
  );

  const contextValue = useMemo(
    () => ({ ItemRenderer: children, columns: rest.itemData.columns, contentWidth }),
    [children, rest.itemData.columns, contentWidth],
  );

  return (
    <StickyListContext.Provider value={contextValue}>
      <VariableSizeList {...rest} itemData={itemDataWithRenderer}>
        {ItemWrapper}
      </VariableSizeList>
    </StickyListContext.Provider>
  );
};

export default StickyList;